import {observable, action} from 'mobx'
import {notification} from 'antd'

export class Payment {
  @observable stripeToken
  @observable plans
  @observable invoices

  constructor(rootStore) {
    this.rootStore = rootStore
    this.plans = {
      loading: false,
      page: 1,
      count: 0,
      size: 0,
      results: []
    }
    this.invoices = {
      loading: false,
      page: 1,
      count: 0,
      size: 0,
      results: []
    }
  }

  @action getPlans(page = 1) {
    this.plans.page = page
    this.plans.loading = true
    return this.rootStore.api.request(`billing/plans/?page=${page}`, 'get')
      .then(resObj => {
        this.plans.loading = false
        this.plans.count = resObj.count
        if (page === 1) {
          this.plans.size = resObj.results.length
        }
        this.processPlans(resObj.results)
      }).catch((e) => {
        this.plans.loading = false
        notification['error']({
          message: 'Failed to get billing plans',
          description: e.message || 'Unknown error'
        })
      })
  }

  @action processPlans(data) {
    let table = []
    data.map(row => {
      table.push({
        key: row.djstripe_id,
        name: row.name,
        description: row.description,
        amount: row.amount,
        currency: row.currency,
        interval: row.interval,
        interval_count: row.interval_count,
        trial_period_days: row.trial_period_days
      })
    })
  }

  @action getInvoices(page = 1) {
    this.invoices.page = page
    this.invoices.loading = true
    return this.rootStore.api.request(`billing/invoices/?page=${page}`, 'get')
      .then(resObj => {
        this.invoices.loading = false
        this.invoices.count = resObj.count
        if (page === 1) {
          this.invoices.size = resObj.results.length
        }
        this.invoices.results = resObj.results
      }).catch((e) => {
        this.invoices.loading = false
        notification['error']({
          message: 'Failed to get invoices',
          description: e.message || 'Unknown error'
        })
      })
  }

  @action getSubscription() {
    return this.rootStore.api.request('billing/subscription', 'get')
      .then(() => {

      }).catch((e) => {
        notification['error']({
          message: 'Failed to subscription',
          description: e.message || 'Unknown error'
        })
      })
  }

  @action addCard(sendInvoice) {
    let body = {
      stripe_token: this.stripeToken
    }
    if (typeof sendInvoice === 'boolean') {
      body.send_invoice = sendInvoice
    }

    return this.rootStore.api.request('billing/add-card', 'post', body)
      .then(() => {

      }).catch((e) => {
        notification['error']({
          message: 'Failed to add card',
          description: e.message || 'Unknown error'
        })
      })
  }

  @action subscribe() {
    return this.rootStore.api.request('billing/subscription', 'post')
      .then(() => {

      }).catch((e) => {
        notification['error']({
          message: 'Failed to subscribe',
          description: e.message || 'Unknown error'
        })
      })
  }

  @action unsubscribe() {
    return this.rootStore.api.request('billing/subscription', 'delete')
      .then(() => {

      }).catch((e) => {
        notification['error']({
          message: 'Failed to unsubscribe',
          description: e.message || 'Unknown error'
        })
      })
  }

  @action cancel() {
    return this.rootStore.api.request('billing/cancel', 'delete')
      .then(() => {

      }).catch((e) => {
        notification['error']({
          message: 'Failed to cancel',
          description: e.message || 'Unknown error'
        })
      })
  }
}
